import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{ref:"reqSpecField",attrs:{"disabled":!_vm.req.filter.doc,"color":"teal","label":"Specialization","items":_vm.getReqSpecs,"item-text":"sp_name","auto-select-first":"","return-object":"","autocomplete":"nope"},on:{"change":function($event){return _vm.handleChangeReqSpecField($event)}},model:{value:(_vm.specField),callback:function ($$v) {_vm.specField=$$v},expression:"specField"}})
}
var staticRenderFns = []

export { render, staticRenderFns }